import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { clientPolicyIngsight } from "../../App";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import FormFilling from "../../components/FormsManagement/FormFilling/FormFilling";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { GET_FORM_QUESTIONS } from "../../GraphQL/Queries";

const PreviewFormContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const [questionsData, setQuestionsData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [mandatoryMissing] = useState([]);
  const [QuestionsSave, setQuestionsSave] = useState([]);
  const [formSelected, setFormSelected] = useState();

  const [runQueryFormQuestions] = useLazyQuery(GET_FORM_QUESTIONS, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.formQuestionsByIdForm) {
        let questions = data.formQuestionsByIdForm;
        questions = questions.map((e) => {
          return {
            ...e,
            tpsurveyAnswerQuestionSurveys: [
              {
                internalCode: null,
              },
            ],
          };
        });
        setQuestionsData([...questions]);
        setShowLoader(false);
      }
    },
  });

  const saveForm = () => {};

  const goToBackPage = () => {
    history.push({ pathname: `/PolicyFormsManagement` });
  };

  useEffect(() => {
    if (location.state.data) {
      setShowLoader(true);
      let config = JSON.parse(location.state.data.jsonConfiguration);
      let buttonText = config?.TextButtonSave?.jsonConfiguration;
      buttonText = JSON.parse(buttonText)?.text;
      let titleText = config?.Title?.jsonConfiguration;
      titleText = JSON.parse(titleText)?.text;
      setFormSelected({
        value: location.state.data.idForm,
        label: location.state.data.name,
        title: titleText,
        buttonText,
      });
    }
  }, []);

  useEffect(() => {
    if (formSelected && location.state.data) {
      let formId = location.state.data.idForm;
      if (formId) {
        runQueryFormQuestions({ variables: { idForm: formId } });
      }
    }
  }, [formSelected]);

  return (
    <>
      <BackButtonComponent
        bgBack={"#fff"}
        backtitle={""}
        locationtitle={""}
        goToBackPage={goToBackPage}
      />
      {formSelected && (
        <FormFilling
          formData={formSelected}
          questiondata={questionsData}
          saveForm={saveForm}
          mandatoryMissing={mandatoryMissing}
          QuestionsSave={QuestionsSave}
          setQuestionsSave={setQuestionsSave}
          buttonSaveConfigurationPreview={false}
        />
      )}
      {showLoader && <ModalLoader />}
    </>
  );
};

export default PreviewFormContainer;
